import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ReviewGroupsOutliersPage = lazy(
  () => import('~/features/content-enrichment/pages/review-groups-outliers-page'),
);

export const Route = createFileRoute(
  '/_authenticated/_tenant/experiments_/$expId/content-enrichment/groups',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ReviewGroupsOutliersPage />
    </Suspense>
  ),
});
